// extracted by mini-css-extract-plugin
export var content = "_qp-1";
export var fullScreen = "_qp-0";